import "../../styles/table.css";
import axios from "axios";
import Cookies from "js-cookie";
import jwtDecode from "jwt-decode";
import { useEffect, useState } from "react";
import { useDataContext } from "../../utils/DataContext";
import { Button } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { openFiftyOne } from "../../utils/fiftyone";
import { buttonText } from "../../utils/buttonText";
import { pageText } from "../../utils/pageText";

function Tables() {
  return (
    <div className="silver-tables">
      <InputGroup />
      <TableGallery />
    </div>
  );
}

function InputGroup() {
  const { fetchList } = useDataContext();

  const [tablePath, setTablePath] = useState(null);

  const [showAddModal, setShowAddModal] = useState(false);
  const [deleteAllLoading, setDeleteAllLoading] = useState(false);

  const loadTable = async () => {
    if (!tablePath) {
      window.alert("Please input a table path.");
      return;
    }
    let url = `/ETL/load/table?table_path=${tablePath}`;
    axios
      .put(url)
      .then((response) => {
        fetchList();
        window.alert(`Table "${tablePath}" has been loaded successfully.`);
        setShowAddModal(false);
        setTablePath(null);
      })
      .catch((error) => {
        const errorMsg = error.response.data;
        window.alert(errorMsg);
      });
  };

  const deleteAllTable = async () => {
    setDeleteAllLoading(true);
    axios
      .delete(`/ETL/table/delete`)
      .then((response) => {
        setDeleteAllLoading(false);
        fetchList();
      })
      .catch((error) => {
        setDeleteAllLoading(false);
        let errorMsg = error.response.data;
        window.alert(errorMsg);
      });
  };

  const addTableModal = (
    <Modal show={showAddModal} onHide={() => setShowAddModal(false)}>
      <Modal.Header closeButton closeLabel={buttonText("Close")}>
        <Modal.Title>Load Table</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Control
          type="text"
          id="table-path"
          placeholder="Silver Table Path"
          value={tablePath}
          onChange={(e) => setTablePath(e.target.value)}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setShowAddModal(false)}>
          {buttonText("Close")}
        </Button>
        <Button variant="primary" onClick={loadTable}>
          {buttonText("Load")}
        </Button>
      </Modal.Footer>
    </Modal>
  );

  return (
    <div className="input-group">
      <div className="input-group mb-3">
        <div className="table-group">
          <div className="table-option">
            <Button variant="outline-danger">{buttonText("Delete Selected")}</Button>
            <Button
              variant="outline-danger"
              onClick={deleteAllTable}
              disabled={deleteAllLoading}
            >
              {buttonText(deleteAllLoading ? "Loading..." : "Delete All")}
            </Button>
          </div>
          <div className="add-group">
            <Button variant="primary" onClick={() => setShowAddModal(true)}>
              {buttonText("+ Load More Table")}
            </Button>
          </div>
        </div>
        {addTableModal}
      </div>
    </div>
  );
}

function TableGallery() {
  const { datasetNames } = useDataContext();

  const [checkedItems, setCheckedItems] = useState([]);

  // 从 datasetNames 中过滤出 table 类型的数据集
  const tableItems = datasetNames ? 
    datasetNames.filter(item => 
      item.media_type === 'table' || item.folder_type === 'table'
    ) : [];

  const TablesCards = (props) => {
    const { items } = props;
    return (
      <div className="tableGallery">
        {items &&
          items.map((item) => {
            return (
              <TableItem
                key={`table-${item.name}`}
                item={item}
                checkedItems={checkedItems}
                setCheckedItems={setCheckedItems}
              />
            );
          })}
      </div>
    );
  };

  return <TablesCards items={tableItems} />;
}

function TableItem(props) {
  const { fetchList } = useDataContext();

  const { item, checkedItems, setCheckedItems } = props;

  const [checked, setChecked] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    setChecked(checkedItems.includes(item.name));
  }, [checkedItems, item.name]);

  const deleteTable = async () => {
    setIsDeleting(true);
    const userToken = Cookies.get("user_token");
    const userData = userToken ? jwtDecode(userToken) : null;
    const role = userData ? userData.role : null;
    const organization = userData ? userData.organization : null;
    const method = userToken ? "post" : "delete";
    const data = userToken ? { requesterToken: userToken } : null;
    const q = encodeURIComponent(item.name);
    try {
      await axios({
        method,
        url: `/datasets/delete?dataset_name=${q}&media_type=table`,
        data,
      });
      await axios.delete(`/ETL/table/delete?table_name=${q}`).catch(() => {});
      fetchList();
      setCheckedItems(checkedItems.filter((name) => name !== item.name));
    } catch (error) {
      const errorMsg = error.response?.data || error.message || "Delete failed";
      window.alert(errorMsg);
    } finally {
      setIsDeleting(false);
    }
  };

  const handleCheckboxChange = (e) => {
    let isChecked = e.target.checked;
    setChecked(isChecked);
    let newCheckedItems = [];
    if (isChecked) {
      newCheckedItems = checkedItems.concat([item.name]);
    } else {
      newCheckedItems = checkedItems.filter((name) => name !== item.name);
    }
    setCheckedItems(newCheckedItems.slice());
  };

  return (
    <div className="card" style={{ width: "18rem" }}>
      <div className="container-fluid">
        <div className="row">
          <div className="col col-xl-6 d-flex justify-content-start px-2 py-2">
            <input
              className="form-check-input"
              type="checkbox"
              checked={checked}
              onChange={handleCheckboxChange}
              style={{ left: "0.5rem", top: "0.3rem", scale: "1.5" }}
            />
          </div>
          <div className="col col-xl-6 d-flex justify-content-end px-2 py-2">
            <button
              onClick={() => deleteTable(true)}
              type="button"
              className="btn-close"
              aria-label={buttonText("Close")}
            />
          </div>
        </div>
      </div>
      <div className="card-body" style={{ marginTop: "-1.0rem" }}>
        <button
          type="button"
          className="btn btn-light"
          onClick={() => openFiftyOne(item.name)}
        >
          <h5 className="card-title">{item.name}</h5>
        </button>
        
        <div style={{ fontSize: '0.9em', marginTop: '0.5rem' }}>
          {item.valid !== undefined && (
            <p className="card-text" style={{ marginBottom: '0.3rem' }}>
              <strong>{pageText("Valid:")}</strong> {item.valid}
            </p>
          )}
          {item.size && (
            <p className="card-text" style={{ marginBottom: '0.3rem' }}>
              <strong>{pageText("Size:")}</strong> {item.size}
            </p>
          )}
          {/* Table 类型始终显示统计信息，即使为 0 */}
          {(item.media_type === 'table' || item.folder_type === 'table') && (
            <>
              <p className="card-text" style={{ marginBottom: '0.3rem' }}>
                <strong>{pageText("Total Files:")}</strong> {item.total_samples || 0}
              </p>
              <p className="card-text" style={{ marginBottom: '0.3rem' }}>
                <strong>{pageText("Total Labels:")}</strong> {item.label_count || 0}
              </p>
            </>
          )}
          {item.classes && item.classes.length > 0 ? (
            <div className="card-text" style={{ marginTop: '0.5rem' }}>
              <strong>{pageText("Classes:")}</strong>
              <div style={{ 
                marginTop: '4px', 
                display: 'flex', 
                flexWrap: 'wrap', 
                gap: '4px' 
              }}>
                {item.classes.map((cls, idx) => (
                  <span 
                    key={idx}
                    style={{
                      display: 'inline-block',
                      padding: '2px 8px',
                      backgroundColor: '#e3f2fd',
                      color: '#1976d2',
                      borderRadius: '12px',
                      fontSize: '0.8em',
                      border: '1px solid #90caf9'
                    }}
                  >
                    {cls}
                  </span>
                ))}
              </div>
            </div>
          ) : (item.media_type === 'table' || item.folder_type === 'table') ? (
            <div className="card-text" style={{ marginTop: '0.5rem' }}>
              <strong>{pageText("Classes:")}</strong>
              <span style={{marginLeft: 8, color: "#999", fontSize: '0.85em'}}>{pageText("No classes yet")}</span>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default Tables;
